import Dashboard from '@/modules/dashboard/Dashboard';

export default [
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            requiresAuth: true,
        },
    },
];
